import { Box, Typography, Button } from "@mui/material";
import { DataGrid, GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import React, { useContext } from "react";
import { API, graphqlOperation } from "aws-amplify";
import moment from "moment";
import { UserIDContext } from "../../App"; // adjust path if needed

// API call to activate user with specific subscription type
const activateUserOnAWS = async (userId, userType, daysLeft = 0) => {
  const today = moment();
  // Add existing remaining days + 30 new days
  const newDate = today.add(daysLeft + 30, "days").format("MMMM DD, YYYY");
  try {
    const result = await API.graphql(
      graphqlOperation(`
      mutation MyMutation {
        updateUser(
          input: {userTypeChangeDate: "${newDate}", id: "${userId}", userType: "${userType}"}
        ) {
          id
        }
      }
    `)
    );
    console.log(`Activated user ${userId} as ${userType}:`, result);
    alert(`User ${userId} activated as ${userType} for 30 days!`);
  } catch (e) {
    console.error("Activation error:", e);
    alert("Activation failed!");
  }
};

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

function UsersData({ users, dev }) {
  const userIdFromContext = useContext(UserIDContext);

  const columns = [
    {
      field: "createdAt",
      headerName: "SIGN-UP DATE",
      flex: 1,
      type: "date",
      renderCell: (params) => {
        return params.row.createdAt.toLocaleDateString("en-UK", {
          day: "2-digit",
          month: "short",
          year: "2-digit",
        });
      },
    },
    {
      field: "email",
      headerName: "EMAIL",
      flex: 2,
    },
    {
      field: "daysLeft",
      headerName: "SUBSCRIPTION DAYS LEFT",
      flex: 1,
    },
    {
      field: "userAttribue1",
      headerName: "CURRENCY",
      flex: 1,
      renderCell: (params) => params.row.userAttribue1 || "UGX",
    },
  ];
  if (dev) {
    columns.push({
      field: "id",
      headerName: "AWS ID",
      flex: 3,
    });
  }
  columns.push({
    field: "activate",
    headerName: "ACTIVATE",
    flex: 2,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#70d8bd",
            color: "white",
            "&:hover": {
              backgroundColor: "#5bb8a0",
            },
          }}
          onClick={() =>
            activateUserOnAWS(
              params.row.id || userIdFromContext,
              "PRO",
              params.row.daysLeft || 0
            )
          }
        >
          PRO
        </Button>
        <Button
          variant="contained"
          size="small"
          sx={{
            backgroundColor: "#ff6b9d",
            color: "white",
            "&:hover": {
              backgroundColor: "#e55a8a",
            },
          }}
          onClick={() =>
            activateUserOnAWS(
              params.row.id || userIdFromContext,
              "CORPORATE",
              params.row.daysLeft || 0
            )
          }
        >
          CORPORATE
        </Button>
      </Box>
    ),
  });

  return (
    <>
      {users && (
        <Box
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              fontWeight: "bold",
              color: "blue",
            },
          }}
        >
          <Typography component="span" variant="h4">
            Number of Users: {users.length}
          </Typography>
          <DataGrid
            columns={columns}
            rows={users}
            slots={{ toolbar: CustomToolbar }}
            initialState={{
              sorting: {
                sortModel: [{ field: "createdAt", sort: "desc" }],
              },
            }}
          />
        </Box>
      )}
    </>
  );
}

export default UsersData;
